<template>
  <!--角色管理 -->
  <div class="videoPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':0,'value':'待审核'},{'key':1,'value':'审核通过'},{'key':2,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>排序方式：</div>
          <el-select v-model="sortType" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择排序方式">
            <el-option
                v-for="item in [{'key':1,'value':'创建时间'},{'key':2,'value':'权重时间'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>是否推荐：</div>
          <el-select v-model="isRecommend" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择">
            <el-option
                v-for="item in [{'key':1,'value':'是'},{'key':0,'value':'否'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" type="primary" size="small">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="auditBatchList&&auditBatchList.length" @click="auditBatchBtn" size="small" type="danger">批量审核</el-button>
          <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>
        </div>

        <el-table
            size="small"
            ref="multipleTable"
            tooltip-effect="dark"
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column header-align="center" label="用户头像">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-avatar :size="32" :src="scope.row.head_img_url"></el-avatar>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="用户昵称" prop="nickname" align="center"></el-table-column>
          <el-table-column label="是否推荐" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.is_recommend === 0?'否':'是' }}</div>
            </template>
          </el-table-column>
          <el-table-column header-align="center" label="视频">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-button @click="viewVideoBtn(scope.row)" size="small" type="text">播放</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.create_date}}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="权重时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.sortTime}}
                </template>
                {{ scope.row.sortTimeList[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" width="120" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag type="warning" size="small" effect="dark" v-if="scope.row.examine_status === 0">待审核</el-tag>
                <el-tag type="success" size="small" effect="dark" v-else-if="scope.row.examine_status === 1">审核通过</el-tag>
                <el-tag type="danger" size="small" effect="dark" v-else>审核未通过</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="300"
          >
            <template slot-scope="scope">
              <el-button @click="auditBtn(scope.row)" v-if="scope.row.examine_status === 0" size="small" type="success">审核</el-button>
              <el-button @click="editBtn(scope.row)" size="small" type="success">修改</el-button>
              <el-button @click="detailsBtn(scope.row)" size="small" type="primary">详情</el-button>
              <el-button @click="deleteBtn(scope.row)" size="small" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>
    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{simpleDelete?'是否删除该条记录？':'是否删除当前所选中的记录？'}}</div>
    </a-modal>

    <a-modal
        :visible="editDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="修改"
        width="400px"
        @cancel="editCancel"
        @ok="editSubmit('editRuleForm')"
    >
      <el-form
          ref="editRuleForm"
          :model="editRuleForm"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="是否推荐">
          <el-select style="width: 180px" v-model="editRuleForm.isRecommend" placeholder="请选择">
            <el-option
                v-for="item in [{key:0,value:'否'},{key:1,value: '是'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="播放次数">
          <el-input-number :min="0" v-model="editRuleForm.playback"></el-input-number>
        </el-form-item>
        <el-form-item label="排序权重">
<!--          <el-input-number :min="0" v-model="editRuleForm.sort"></el-input-number>-->
          <el-date-picker
              v-model="editRuleForm.sort"
              type="datetime"
              value-format="timestamp"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    审核的弹窗-->
    <a-modal
        :visible="auditDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="审核"
        width="400px"
        @cancel="auditCancel"
        @ok="auditSubmit('auditRuleForm')"
    >
      <el-form
          ref="auditRuleForm"
          :model="auditRuleForm"
          :rules="auditRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="审核状态" prop="examineStatus">
          <el-select v-model="auditRuleForm.examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':1,'value':'审核通过'},{'key':2,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>

    <a-modal
        :visible="videoDialogState"
        title="视频"
        width="1200px"
        @cancel="videoDialogCancel"
    >
      <template slot="footer">
        <a-button key="back" v-show="false">
          Return
        </a-button>
        <a-button @click="videoDialogCancel" key="submit" v-show="true">
          关闭
        </a-button>
      </template>
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";

export default {
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      examineStatus:null,
      sortType:null,
      isRecommend:null,
      tableData:[],
      totalElements: 0,//数据总数
      multipleSelection:[],
      auditBatchList:[],
      deleteDialogState:false,
      deleteId:'',
      simpleDelete:false,//是单个删除还是多个删除
      auditDialogState:false,
      auditRuleForm:{
        examineStatus:null
      },
      auditRules:{
        examineStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
      },
      simpleAudit:false,
      auditId:'',
      editDialogState:false,
      editRuleForm:{
        id:'',
        isRecommend:1,
        playback:0,
        sort:0
      },
      videoDialogState:false,
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          //类型
          type: "video/mp4",
          //url地址
          src: ''
        }],
        //你的封面地址
        poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      }
    };
  },
  methods: {
    videoDialogCancel(){
      this.player.pause()
      this.videoDialogState = false
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getDynamicList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.sortType = null
      this.isRecommend = null
      this.getDynamicList()
    },
    detailsBtn(row){
      this.$router.push({ path: "/details",query:{
          row:row
        }});
    },
    editBtn(row){
      this.editRuleForm.id = row.id
      this.editRuleForm.playback = row.playback
      this.editRuleForm.sort = row.sort
      this.editRuleForm.isRecommend = row.is_recommend
      this.editDialogState = true
    },
    deleteBtn(row){
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    viewVideoBtn(row){
      this.playerOptions.sources[0].src = row.video_url
      console.log(this.playerOptions.sources[0].src)
      this.videoDialogState = true
    },
    auditBtn(row){
      this.simpleAudit = true
      this.auditId = row.id
      this.auditRuleForm.examineStatus = 1
      this.auditDialogState = true
    },
    batchDeleteBtn(){
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    auditBatchBtn(){
      this.simpleAudit = false
      this.auditRuleForm.examineStatus = 1
      this.auditDialogState = true
    },
    deleteCancel(){
      this.deleteDialogState = false
    },
    auditCancel(){
      this.auditDialogState = false
    },
    editCancel() {
      this.editDialogState = false
    },
    editSubmit(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.editRuleForm,999)
          this.postAxios("/newsVideo/updNewsVideoById", this.editRuleForm).then(res=>{
            if (res.success){
              this.$message.success(res.message)
              this.editDialogState = false
              this.getDynamicList()
            }
          })
        }
      });
    },
    auditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.simpleAudit){
            this.postAxios("/newsVideo/updNewsVideoExamineStatusById", {
              examineStatus:this.auditRuleForm.examineStatus,
              ids:[this.auditId]
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditId = ''
                this.auditDialogState = false
                this.getDynamicList()
              }
            })
          }else{
            this.postAxios("/newsVideo/updNewsVideoExamineStatusById", {
              examineStatus:this.auditRuleForm.examineStatus,
              ids:this.auditBatchList
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditBatchList = []
                this.multipleSelection = []
                this.auditDialogState = false
                this.getDynamicList()
              }
            })
          }
        }
      });
    },
    deleteSubmit(){
      if (this.simpleDelete){
        //单个删除
        this.postAxios("/newsVideo/delNewsVideoByIds", [
          this.deleteId
        ]).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getDynamicList()
          }
        })
      }else{
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item)=>{
          ids.push(item.id)
        })
        this.postAxios("/newsVideo/delNewsVideoByIds", ids).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getDynamicList()
          }
        })
      }
    },
    //用户列表
    getDynamicList() {
      this.postAxios("/newsVideo/getAllNewsVideo", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          examineStatus: this.examineStatus === '' ? null : this.examineStatus,
          sortType:this.sortType?this.sortType:null,
          isRecommend:this.isRecommend ? this.isRecommend : this.isRecommend === 0 ? this.isRecommend : null,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.tableData.forEach((item)=>{
            item.sortTime = moment(item.sort).format('YYYY-MM-DD HH:mm:ss')
            item.sortTimeList = item.sortTime.split(' ')
            item.create_date_list = item.create_date.split(' ')
            if (item.dynamicImgEntitys&&item.dynamicImgEntitys.length){
              item.url = item.dynamicImgEntitys[0].url
              item.urlList = []
              item.dynamicImgEntitys.forEach((childItem)=>{
                item.urlList.push(childItem.url)
              })
            }
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.auditBatchList = []
      console.log(this.multipleSelection,999)
      if (this.multipleSelection&&this.multipleSelection.length){
        this.multipleSelection.forEach((item)=>{
          if (item.examine_status === 0){
            this.auditBatchList.push(item.id)
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getDynamicList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getDynamicList()
    }
  },
  created() {
    this.getDynamicList(); //用户的列表
  }
};
</script>
<style lang="less" scoped>
</style>
